export default {
  hiddenTips: 'Refresh the page after <span style="color:#0066FF">commenting</span> to see the rest of the content. Participate now!<br />(Comments may be delayed due to content review)',
  mentionInArticle: 'Mentioned in the article',
  polledIn: '',
  confirmChangeLable: 'Are you sure you want to overwrite all previous labels?',
  selectedImg: 'Selected images',
  selectLable: 'Replaced with the selected label',
}